import DesktopMenu from './desktop-menu';

export default DesktopMenu;